import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { MomentModule } from "angular2-moment";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

///ngx-translate
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

///ngx-bootstrap
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { ModalModule } from "ngx-bootstrap/modal";

import { AuthInterceptor } from "./auth.interceptor";

///ngx-spinner
import { NgxSpinnerModule } from "ngx-spinner";

////services
import { WidgetService } from "./widget.service";
import { CookieService } from "angular2-cookie/core";

///components
import { AppComponent } from "./app.component";
import { StepOneComponent } from "./step-one/step-one.component";
import { StepThreeComponent } from "./step-three/step-three.component";
import { StepTwoComponent } from "./step-two/step-two.component";
import { DropdownComponent } from "./components/dropdown/dropdown.component";
import { RegisterFormComponent } from "./components/register-form/register-form.component";
import { LoginFormComponent } from "./components/login-form/login-form.component";
import { AppointmentSlotsComponent } from "./components/appointment-slots/appointment-slots.component";
import { environment } from "../environments/environment";
import { MobilePhoneInputComponent } from "./components/mobile-phone-input/mobile-phone-input.component";

export function HttpLoaderFactory(http: HttpClient) {
  let location = window.location.host;
  let translationsPath = environment.translationsPath;
  if (location.indexOf("localhost") !== -1) {
    return new TranslateHttpLoader(http);
  }
  return new TranslateHttpLoader(http, `/${translationsPath}/assets/i18n/`);
  //"/widget/assets/i18n/"
}

export function cookieServiceFactory() {
  return new CookieService();
}

@NgModule({
  declarations: [
    AppComponent,
    StepOneComponent,
    StepTwoComponent,
    StepThreeComponent,
    DropdownComponent,
    RegisterFormComponent,
    LoginFormComponent,
    AppointmentSlotsComponent,
    MobilePhoneInputComponent,
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot([{ path: "", component: AppComponent }]),
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    BsDropdownModule.forRoot(),
    BsDatepickerModule.forRoot(),
    ModalModule.forRoot(),
    MomentModule,
    FormsModule,
    NgxSpinnerModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    WidgetService,
    { provide: CookieService, useFactory: cookieServiceFactory },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// C:/Users/strahinja.aparac/Desktop/git/source/healthcare/v2/app/appointment-widget/src/app/app.module.ts